function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M131,40L157,40.276L157,183L38,183L38,15L131.137,15L131,40Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "13.35px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.137,15L157,40.276",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "13.35px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,40L110,40L57,40Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "13.35px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,67L137,67",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "13.35px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123,67L137,67",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "13.35px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123,67L137,67",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "13.35px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123,67L137,67",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "13.35px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,67L137,67",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "13.35px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2,-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 92,
    width: 44,
    height: 44,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "13.35px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.aa54c13c1c97b2f97fc2e45282a0a2c7.svg";
export { ForwardRef as ReactComponent };